<template>
  <div class="table-body-item-content">
    <div class="table-body-item-content-item">
      <div class="title">订单信息</div>
      <div class="info-detail">
        <div class="detail-item">
          <div>
            <span>订单编号</span>
            {{ tableData.cmsStorageOrder.orderNum }}
          </div>
          <div>
            <span>订单状态</span>
            {{ tableData.orderStatus }}
          </div>
          <div>
            <span>生成日期</span>
            {{ tableData.cmsStorageOrder.createDate }}
          </div>
        </div>
        <div class="detail-item">
          <div style="color:#5EA944">
            <span>储存位置</span>
            {{ tableData.cmsStorageOrder.storagePlace }}
          </div>
          <div>
            <span>储存位置详细地址</span>
            {{ tableData.cmsStorageOrder.storagePlaceDtl }}
          </div>
        </div>
        <div class="detail-item">
          <div>
            <span>仓单名称</span>
            {{ tableData.cmsStorageOrder.storageName }}
          </div>
          <div>
            <span>订单价格</span>
            {{ tableData.cmsStorageOrder.money }}元
          </div>
          <div>
            <span>付款方式</span>
            {{ tableData.cmsStorageOrder.payType }}
          </div>
        </div>
        <div class="detail-item">
          <div>
            <span>租用开始时间</span>
            {{ tableData.cmsStorageOrder.leaseStartTime }}--{{ tableData.cmsStorageOrder.leaseEndTime }}
          </div>
          <div>
            <span>租用天数</span>
            {{ tableData.cmsStorageOrder.leaseDay }}天
          </div>
        </div>
        <div class="detail-item">
          <div>
            <span>租用面积</span>
            {{ tableData.leaseArea }}㎡
          </div>
          <div>
            <span>仓库类型</span>
            {{ tableData.storageType }}
          </div>
          <div>
            <span>库内设备</span>
            {{ tableData.warehouseEquipment }}
          </div>
        </div>
        <div class="detail-item">
          <div>
            <span>储货类型</span>
            {{ tableData.houseGoodsType }}
          </div>
          <div>
            <span>地坪质地</span>
            {{ tableData.floorTexture }}
          </div>
          <div>
            <span>地坪承重</span>
            {{ tableData.floorWeight }}吨
          </div>
        </div>
        <div class="detail-item">
          <div>
            <span>卸货平台</span>
            {{ tableData.landingPlatform }}
          </div>
          <div>
            <span>消防资质</span>
            {{ tableData.fireQualification }}
          </div>
        </div>
      </div>
    </div>
    <!-- 图片展示 -->
    <div class="table-body-item-content-item">
      <el-row>
        <el-col class="marginbottom27 title" :span="6">
          仓储图片
        </el-col>
      </el-row>
      <el-row class="center" :span="20">
        <el-row v-viewer class="center img-warp">
          <div v-for="item in fileUrl(tableData.cmsStorageOrder)" :key="item" class="img-box">
            <img class="el-image" :src="item | getImg">
          </div>
        </el-row>
      </el-row>
    </div>

    <div class="table-body-item-content-item">
      <div class="title">供给方信息</div>
      <div class="info-detail">
        <div class="detail-item">
          <div>
            <span>供给公司名称</span>
            {{ tableData.cmsStorageOrder.supplyCompany }}
          </div>
          <div>
            <span>供给方联系人</span>
            {{ tableData.cmsStorageOrder.supplyPerson }}
          </div>
          <div>
            <span>供给方联系方式</span>
            {{ tableData.cmsStorageOrder.storageTel }}
          </div>
        </div>
        <div class="detail-item">
          <div>
            <span>供给方公司地址</span>
            {{ tableData.cmsStorageOrder.storageAddress }}
          </div>
        </div>
      </div>
    </div>

    <div class="table-body-item-content-item">
      <div class="title">需求方信息</div>
      <div class="info-detail">
        <div class="detail-item">
          <div>
            <span>需求公司名称</span>
            {{ tableData.cmsStorageOrder.demandCompany }}
          </div>
          <div>
            <span>需求方联系人</span>
            {{ tableData.cmsStorageOrder.demandPerson }}
          </div>
          <div>
            <span>需求方联系方式</span>
            {{ tableData.cmsStorageOrder.demandTel }}
          </div>
        </div>
        <div class="detail-item">
          <div>
            <span>需求方公司地址</span>
            {{ tableData.cmsStorageOrder.demandAddress }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StorageOrderListTableItem',
  props: {
    tableData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      tableitem: false
    }
  },
  computed: {
    fileUrl(item) {
      // 图片回调
      return item => {
        if (item.storageUrl == null || item.storageUrl === '') {
          return false
        }
        return item.storageUrl.split(',').filter(n => n) // 数组去空
      }
    }
  },
  mounted() {
    console.log(this.tableData)
  },
  methods: {
    // 订单状态字体颜色
    orderStatusLabel(status) {
      const obj = {
        '1': '#148B00',
        '2': '#E56100'
      }
      return obj[status]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../order-list.scss';
  .center{
    text-align: center;
  }
  .table-body-item-content-item{
    .title{
      font-size: 15px;
      font-weight: bold;
      color: rgb(190, 35, 22);
      margin-bottom: 20px;
    }
    span:after {
      content: " : ";
    }
    .info-detail {
      display: flex;
      flex-direction: column;
      color: #000000;
      font-weight: normal;
      margin-bottom: 0;
      .detail-item {
        display: flex;
        margin-bottom: 24px;
        div {
          width: 33%;
        }
      }
    }
  }
  // 货物图片
  .img-warp{
    display: flex;
    .img-box{
      width: 135px;
      height: 110px;
      margin-right: 14px;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }

  .table-body{
    &-item{
      box-shadow:0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius:4px;
      &-head{
        font-size: 14px;
        height: 82px;
        background-color: #fff;
      }
      .address{
        font-size: 18px;
        color: #555555;
        font-weight:bold;
        &-box{
          display: flex;
          justify-content: center;
          align-items: baseline;
          div, div img{
            vertical-align:middle
          }
        }
      }
      &-content{
        background-color: #fafbff;
        &-item{
          font-size: 14px;
          padding: 15px 26px;
          border-top: 1px solid rgba(218,218,218,1);
          .title{
            font-size: 16px;
            color: $base-color;
            font-weight: bold;
          }
          .waybill-box-item{
            border: 1px solid #9AB2FF;
            padding: 19px 14px;
            margin-top: 25px;
            .title{
              font-weight:400;
              color: #000;
            }
          }
        }
      }
    }
  }
</style>
